export default __webpack_public_path__ + "static/media/check.4899f625.svg";